import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Login from '@/views/Login'
import VerifyPhone from '@/views/VerifyPhone'
import PlanDetail from '@/views/PlanDetail'
import Paymenthly from '@/views/Paymenthly'
import Profile from '@/views/Profile'
import PaymentSuccessfull from '@/views/PaymentSuccessfull'
import History from '@/views/History'
import policy from '@/views/policy'
import freeTrial from '@/views/freeTrial'
import onlineFreeClass from '@/views/onlineFreeClass'
import salecard from '@/views/salecard'
import PlanInformation from '@/views/PlanInformation'
import NavBar from '@/components/NavBar'
import { getUser } from '../store/user'
import newUser from '@/views/newUser'
import nuinfo from '@/views/nuinfo'
Vue.use(Router)

let router = new Router({
    mode: 'history',
    base:'/pricing/',
    routes: [ {
        path: '/freeTrial',
        name: "freeTrial",
        component: freeTrial
    },
    {
        path: '/freeTrial/:id?',
        name: "freeTrial",
        component: freeTrial
    },{
        path: '/onlineFreeClass',
        name: "onlineFreeClass",
        component: onlineFreeClass
    },
    {
        path: '/onlineFreeClass/:id?',
        name: "onlineFreeClass",
        component: onlineFreeClass
    },
    {
        path: '/salecard',
        name: "salecard",
        component: salecard
    },
    {
        path: '/newUser',
        name: "newUser",
        component: newUser
    },
    {
        path: '/nuinfo',
        name: "nuinfo",
        component: nuinfo
    },

        {
            path: '/',
            name: 'navbar',
            component: NavBar,
            children: [{
                path: '/',
                name: 'index',
                component: Index
            }, {

                path: 'login',
                name: 'login',
                component: Login
            }, {
                path: 'verify',
                name: "verify",
                component: VerifyPhone
            }, {
                path: 'plan-detail',
                name: 'plan-detail',
                component: PlanDetail
            }, {
                path: 'plan-information',
                name: 'plan-information',
                component: PlanInformation
            },{
                path: 'paymenthly',
                name: 'Paymenthly',
                component: Paymenthly
            }, {
                path: 'profile',
                name: 'profile',
                component: Profile
            }, {
                path: 'payment-successfull',
                name: 'payment-successfull',
                component: PaymentSuccessfull
            }, {
                path: 'history/:category',
                name: "history",
                component: History,
                props: {
                    category: String
                }
            },{
                path: 'policy',
                name: "policy",
                component: policy
            },{
                path: '/:id?',
                name: 'index',
                component: Index
            }]
        },
    ],
})

router.beforeEach((to, from, next) => {
    let noValidPages = ['login', 'verify', 'index']
    if (noValidPages.includes(to.name))
        return next()

    let user = getUser()
    if (!user && to.name!="freeTrial" && to.name!="salecard"&& to.name!="newUser"&& to.name!="nuinfo"&& to.name!="onlineFreeClass") {
        next({ path: '/login' })
    } else if (to.name === 'profile' && from.name !== 'verify') {
        next({ path: '/plan-detail' })
    } else {
        next()
    }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js